/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PayByAmountDigitalBillDto } from './PayByAmountDigitalBillDto';
import {
    PayByAmountDigitalBillDtoFromJSON,
    PayByAmountDigitalBillDtoFromJSONTyped,
    PayByAmountDigitalBillDtoToJSON,
} from './PayByAmountDigitalBillDto';
import type { PayCartDto } from './PayCartDto';
import {
    PayCartDtoFromJSON,
    PayCartDtoFromJSONTyped,
    PayCartDtoToJSON,
} from './PayCartDto';

/**
 * 
 * @export
 * @interface CreatePendingPaymentDto
 */
export interface CreatePendingPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePendingPaymentDto
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePendingPaymentDto
     */
    locationId: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePendingPaymentDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePendingPaymentDto
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePendingPaymentDto
     */
    orderReference?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePendingPaymentDto
     */
    deviceId?: string;
    /**
     * 
     * @type {PayCartDto}
     * @memberof CreatePendingPaymentDto
     */
    payCartDto?: PayCartDto;
    /**
     * 
     * @type {PayByAmountDigitalBillDto}
     * @memberof CreatePendingPaymentDto
     */
    payByAmountDigitalBillDto?: PayByAmountDigitalBillDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePendingPaymentDto
     */
    askForTip: boolean;
}

/**
 * Check if a given object implements the CreatePendingPaymentDto interface.
 */
export function instanceOfCreatePendingPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentMethodId" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "askForTip" in value;

    return isInstance;
}

export function CreatePendingPaymentDtoFromJSON(json: any): CreatePendingPaymentDto {
    return CreatePendingPaymentDtoFromJSONTyped(json, false);
}

export function CreatePendingPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePendingPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethodId': json['paymentMethodId'],
        'locationId': json['locationId'],
        'amount': json['amount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'orderReference': !exists(json, 'orderReference') ? undefined : json['orderReference'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'payCartDto': !exists(json, 'payCartDto') ? undefined : PayCartDtoFromJSON(json['payCartDto']),
        'payByAmountDigitalBillDto': !exists(json, 'payByAmountDigitalBillDto') ? undefined : PayByAmountDigitalBillDtoFromJSON(json['payByAmountDigitalBillDto']),
        'askForTip': json['askForTip'],
    };
}

export function CreatePendingPaymentDtoToJSON(value?: CreatePendingPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethodId': value.paymentMethodId,
        'locationId': value.locationId,
        'amount': value.amount,
        'currency': value.currency,
        'orderReference': value.orderReference,
        'deviceId': value.deviceId,
        'payCartDto': PayCartDtoToJSON(value.payCartDto),
        'payByAmountDigitalBillDto': PayByAmountDigitalBillDtoToJSON(value.payByAmountDigitalBillDto),
        'askForTip': value.askForTip,
    };
}

